import { component } from 'flightjs';

function PreventDefault() {
    this.defaultAttrs({
        preventDefault: '[data-prevent-default]'
    });

    this._preventDefaultClick = function(evt) {
        evt.preventDefault();
    };

    this.after('initialize', function() {
        this.on('click', {
            preventDefault: this._preventDefaultClick
        });
    });
}
export default component(PreventDefault);
